import React from "react"
import { graphql, Link } from "gatsby"
import TwoCol from "gatsby-theme-wirehead-bulma/src/twocol"
import Layout from "gatsby-theme-wirehead-bulma/src/layout"
import GalleryList from "../components/gallerylist"
import SEO from "gatsby-theme-wirehead-bulma/src/seo"
import RecentBlogsBlob from "../components/recentblogsblob"

const PostLink = ({ post }) => {
  return (
    <li><Link to={post.node.path} key={post.node.path} className="navbar-item">
      {post.node.context.title}
    </Link></li>
  )
}

const PhotoPage = ({
  data: {
    photos: { photoEdges },
    hierarchy: { hierarchyEdges },
  },
  pageContext,
  location,
}) => {
  const ChildPages = hierarchyEdges.map(edge => {
    return (<li>
      <PostLink key={edge.node.path} post={edge} />
      </li>
    )
  })

  const Photos = photoEdges.map(edge => {
    return (
      <div className="card mbox">
      <div className="card-image">
      <figure className="image">
      <Link to={"/" + edge.node.slug} key={edge.node.slug}><img srcSet={edge.node.image.srcSet} alt={edge.node.frontmatter.title}/></Link>
      </figure>
      </div>
      <div class="card-content">
      <Link to={"/" + edge.node.slug} key={edge.node.slug}>{edge.node.frontmatter.title}</Link>
      </div>
      </div>
    );
  })

  return (<Layout>
    <SEO title={pageContext.title} />
    <section className="section">
    <TwoCol
        left={
          <div className="content">
            <h1 className="title">Recent photos:</h1>
            <div>
            {Photos}
            </div>
          </div>
        }
        right={
          <aside className="menu">
          <p className="menu-label">Galleries</p>
          <GalleryList />
          <p className="menu-label">Pages</p>
          <ul className="menu-list">
          {ChildPages}
          </ul>
          </aside>
        }
      />
     <div className="columns">
      <div className="column">
        <div className="content">
          <h3>About these photographs:</h3>
          <p>My photographs tend to be mostly unprocessed. As with any quality image, it is impossible to avoid some level of manipulation -- usually adjusting color balances and toning slightly, a little bit of cropping, dust removal, etc.</p>
          <p>However, I will note with pride that all of the unique effects I've achieved have been accomplished by careful understanding and control of the light and camera, not through later editing in any sort of software package.</p>
        </div>
      </div>
      <div className="column is-clearfix">
        <aside>
          <h3>Recent Blog Posts:</h3>
          <RecentBlogsBlob />
        </aside>
      </div>
    </div>
    </section>
  </Layout>);
}

export default PhotoPage

export const pageQuery = graphql`
  {
    photos: allMdx(
      filter: {frontmatter: {type: {eq: "Photo"}}, slug: {regex: "^/photo\\/.*/"}}
      limit: 10
      sort: {order: DESC, fields: frontmatter___date}
    ) {
      photoEdges: edges {
        node {
          id
          slug
          frontmatter {
            title
          }
          image {
            id
            key
            maxSize
            size
            srcSet
            srcPath
            width
            height
            sqSrcSet
            srcSet
            thumbnails {
              m {
                height
                width
                file
              }
            }
          }
        }
      }
    }
    hierarchy:allSitePage(
      sort: { fields: context___date, order: DESC }
      filter: { context: { type: {ne: "PhotoIndex"}, date: {ne: null}, parent: { eq: "/photo" } } }
    ) {
      hierarchyEdges:edges {
        node {
          id
          path
          context {
            id
            name
            parent
            title
            type
            depth
            date
            excerpt
          }
        }
      }
    }
  }
`


export const frontmatter = {
  title: "Photos",
}